export enum UploadFileActionEnum {
  Replace = 'replace',
  KeepBoth = 'keepBoth',
}
